/* 🤖 this file was generated by svg-to-ts */
export const mgcIconLeftSmallRegular: {
  name: 'left-small-regular';
  data: string;
} = {
  name: 'left-small-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12.813 8.204a1.336 1.336 0 0 0-.3.098c-.073.036-.812.744-1.641 1.572-1.653 1.651-1.68 1.684-1.68 2.126 0 .441.027.476 1.68 2.128 1.652 1.653 1.687 1.68 2.128 1.68.392 0 .705-.192.893-.547.112-.212.118-.657.012-.861-.04-.077-.579-.648-1.199-1.27L11.581 12l1.125-1.13c.62-.622 1.159-1.193 1.199-1.27.106-.204.1-.649-.012-.861a.995.995 0 0 0-1.08-.535"/></svg>`
};
